import axios from "axios";
import { FormData } from "../models/responses/FormData";

const baseUrl = "/AutoConnectSSO/api/InscriptionFlow/InscriptionFlowForms";

function getFormUrl(name: string, idFormType: number) {
  return `/${name}/${idFormType}`;
}

function getRouteUrl(name: string, field: string) {
  return `/${name}/${field}`;
}

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function getFormData(name: string, idFormType: number) {
  const url = getFormUrl(name, idFormType);
  const response = await instance.get<FormData>(url);
  return response.data;
}

async function getEmail(name: string) {
  const url = getRouteUrl(name, "GetEmail");
  const response = await instance.get<FormData>(url);
  return response.data;
}

async function getNationalId(name: string) {
  const url = getRouteUrl(name, "GetNationalId");
  const response = await instance.get<FormData>(url);
  return response.data;
}

export const InscriptionFlowService = {
  getFormData,
  getEmail,
  getNationalId
};
